import Vue from 'vue';

//Global State Management
export const state = Vue.observable({
	//current app user
	currentUser: '',

	//upload page - parsed results
	parsedResults: [],

	validatedHeader: null,
	validatedParsedResults: [],
	duplicateParsedResults: [],

	newlyAddedInvoiceNo: '',
	newlyAddedPONo: ''
});

export const getters = {
	getCurrentUser: () => state.currentUser,
	getParseResults: () => state.parsedResults,
	getValidatedHeader: () => state.validatedHeader,
	getValidatedParsedResults: () => state.validatedParsedResults,
	getDuplicateParsedResults: () => state.duplicateParsedResults
}